import React, { useCallback,useContext, useState } from 'react'

import { Button, Div, Label } from '@driftt/tide-core'

import { DeserializedSavedFilter } from 'api'
import FiltersForm from 'components/FiltersForm'
import { FilterGroup,FilterPage, FiltersContext } from 'context/filtersContext'
import { useAttributeFilters } from 'hooks/useAttributeFilters'
import useFilterConfiguration from 'hooks/useFilterConfiguration'
import { useOnClickOutsideWithPortals } from 'hooks/useOnClickOutside'
import { defaultFilterTypes } from 'utils/filters'

import styles from './styles.module.css'

interface FilterCardProps {
  onClose: () => void
  onOpenEditModal: (filter?: DeserializedSavedFilter, filterGroups?: FilterGroup[]) => void
  setActiveFilterId: (id: number | undefined) => void
}

const CCRMFiltersCard: React.FC<FilterCardProps> = ({
  onClose,
  onOpenEditModal,
  setActiveFilterId
}) => {
  const [refElement, setRefElement] = useState<HTMLElement | null>(null)

  const { filterGroupsByPage, onChangeFilterGroups } = useContext(FiltersContext)
  const filterGroups = filterGroupsByPage[FilterPage.ACTIVITIES]
  const [updatedFilterGroups, setUpdatedFilterGroups] = useState(filterGroups)

  const attributeFilters = useAttributeFilters()
  const filterConfiguration = useFilterConfiguration(attributeFilters, defaultFilterTypes)

  const handleApplyFilters = useCallback(() => {
    setActiveFilterId(undefined)
    onChangeFilterGroups(updatedFilterGroups, FilterPage.ACTIVITIES)
    onClose()
  }, [updatedFilterGroups, onClose, onChangeFilterGroups, setActiveFilterId])

  const handleSaveFilters = useCallback(() => {
    onOpenEditModal(undefined, updatedFilterGroups)
    onClose()
  }, [onClose, onOpenEditModal, updatedFilterGroups])

  const handleChangeFilterGroups = useCallback(
    (filterGroups: FilterGroup[]) => {
      setUpdatedFilterGroups(filterGroups)
    },
    []
  )

  useOnClickOutsideWithPortals(refElement, (e: MouseEvent) => {
    e.stopPropagation()
    onClose()
  })

  return (
    <div ref={setRefElement} className={styles.cardStyle}>
      <Label>Filter</Label>
      <Div className={styles.cardForm}>
        <FiltersForm
          initialGroups={filterGroups}
          onChangeFilterGroups={handleChangeFilterGroups}
          filterConfiguration={filterConfiguration}
          onClose={onClose}
        />
      </Div>
      <Div className={styles.footerContainer}>
        <Div>
          <Button onClick={handleApplyFilters} type="primary" className={styles.marginRight}>
            Apply
          </Button>
          <Button onClick={onClose} type="tertiary">
            Cancel
          </Button>
        </Div>
        <Button onClick={handleSaveFilters} type="secondary">
          Save filters
        </Button>
      </Div>
    </div>
  )
}

export default CCRMFiltersCard
